import { render, staticRenderFns } from "./SvgImage.vue?vue&type=template&id=3902b43a&"
import script from "./SvgImage.vue?vue&type=script&lang=js&"
export * from "./SvgImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports